<template>
  <v-container>
    <h1>แสดงตัวอย่างข้อมูล</h1>
    <!-- <pre>{{ created_word }}</pre> -->
    <v-card-title>
      <v-spacer></v-spacer>
      <v-btn
        v-if="$route.params.mode == 'create'"
        tile
        outlined
        @click="publicWord"
        :color="btn_public ? '#0e62ed' : 'grey'"
        :dark="btn_public"
        :block="mobile"
      >
        <v-icon left>mdi-bullhorn</v-icon>
        <h4 class="mt-1">{{ "ประกาศใช้คำทับศัพท์" }}</h4>
      </v-btn>
    </v-card-title>
    <v-row justify="center" align="center">
      <v-col>
        <h1>
          {{
            created_word.mean ? '" ' + created_word.mean.trim() + ' "' : '" - "'
          }}
        </h1>
        <v-list two-line>
          <v-list-item v-for="(item, i) in created_word.subLanguage" :key="i">
            <v-list-item-avatar tile v-if="item.languageId">
              <v-img
                v-if="getLanguageFlag(item.languageId)"
                width="24px"
                :src="
                  require('@/assets/flag/' + getLanguageFlag(item.languageId))
                "
              ></v-img>
            </v-list-item-avatar>
            <v-list-item-content class="mt-7">
              <v-list-item-title v-if="getLanguageName(item.languageId)">
                <font class="text_body_6" color="#0c57d2">
                  {{ getLanguageName(item.languageId) }}
                </font>
              </v-list-item-title>
              <v-list-item-subtitle>
                <span class="text_title_5">
                  {{ item.alphabet ? item.alphabet : "-" }}
                </span>
                <span class="text_body_7">{{ " (คำทับศัพท์ : " }}</span>
                <span
                  class="text_body_7"
                  v-for="(transcription, index) in item.transcriptionList"
                  :key="index"
                >
                  {{
                    index != 0
                      ? ", " + transcription.transcriptionName
                      : transcription.transcriptionName
                  }}
                </span>
                <span class="text_body_7">
                  {{ ")" }}
                </span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-row>
          <v-col style="margin-left:72px">
            <font class="text_title_5" color="grey">{{ "หมวดหมู่ " }}</font>
            <span class="text_title_5 ml-5">
              {{
                created_word.categoryId
                  ? getCategoryName(created_word.categoryId)
                  : "-"
              }}
            </span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    created_word() {
      return this.$store.state.moduleCreateEditWord.created_word;
    },

    category_list() {
      return this.$store.state.moduleCreateEditWord.category_list;
    },
    language_list() {
      return this.$store.state.moduleCreateEditWord.language_list;
    },
    mobile() {
      if (
        this.$vuetify.breakpoint.width >= 320 &&
        this.$vuetify.breakpoint.width < 768
      ) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (
        this.$vuetify.breakpoint.width >= 768 &&
        this.$vuetify.breakpoint.width < 1440
      ) {
        return true;
      } else {
        return false;
      }
    },
    desktop() {
      if (this.$vuetify.breakpoint.width >= 1440) {
        return true;
      } else {
        return false;
      }
    },
    btn_public() {
      return this.$store.state.moduleCreateEditWord.btn_public;
    },
  },
  watch: {
    btn_public(val) {
      this.created_word.subLanguage.forEach((element) => {
        element.subLanguageStatus = val ? "active" : "pending";
      });
      if (val) {
        this.swalPublic();
      } else {
        this.swalUnpublic();
      }
    },
    // created_word: {
    //   handler(val) {
    //     val.subLanguage.forEach((element) => {
    //       element.subLanguageStatus = this.btn_public ? "active" : "pending";
    //     });
    //   },
    // },
  },
  methods: {
    swalPublic() {
      this.$swal.fire({
        icon: "info",
        title: "ประกาศใช้คำทับศัพท์",
        html:
          "คำทับศัพท์จะถูก<strong>ประกาศใช้ </strong>หลังจากสร้างคำสำเร็จ<br/>สถานะ : คำทับศัพท์ที่เผยแพร่แล้ว",
        confirmButtonText: "ตกลง",
      });
    },
    swalUnpublic() {
      this.$swal.fire({
        icon: "info",
        title: "ไม่ประกาศใช้คำทับศัพท์",
        html:
          "คำทับศัพท์จะ<strong>ไม่ถูกประกาศใช้ </strong>หลังจากสร้างคำสำเร็จ<br/>สถานะ : คำทับศัพท์ที่รอการเผยแพร่",
        confirmButtonText: "ตกลง",
      });
    },
    publicWord() {
      this.$store.state.moduleCreateEditWord.btn_public = !this.$store.state
        .moduleCreateEditWord.btn_public;
      // this.created_word.subLanguage.forEach((element) => {
      //   element.subLanguageStatus = this.btn_public ? "active" : "pending";
      // });
    },
    getCategoryName(id) {
      var category_name = "";
      this.category_list.forEach((element) => {
        if (element.categoryId == id) {
          category_name = element.categoryName;
        }
      });
      return category_name;
    },
    getLanguageName(id) {
      var language_name = "";
      this.language_list.forEach((element) => {
        if (element.languageId == id) {
          language_name = element.languageName;
        }
      });
      return language_name;
    },
    getLanguageFlag(id) {
      var language_flag = "";
      this.language_list.forEach((element) => {
        if (element.languageId == id) {
          language_flag = element.languagePathImg;
        }
      });
      // console.log(language_flag);
      return language_flag;
    },
  },
};
</script>
